import React from 'react'
import CSSModules from 'react-css-modules'
import Navigation from 'react-toolbox/lib/navigation'
import Scroll from 'react-scroll'

import SideNavSpecificationIconButton from './SideNavSpecificationIconButton'
import SideNavApproverIconButton from './SideNavApproverIconButton'
import SideNavCommentIconButton from './SideNavCommentIconButton'
import SideNavHistoryIconButton from './SideNavHistoryIconButton'

import theme from './SideNavBar.scss'

let Link = Scroll.Link

class SideNavBar extends React.Component {
  createLink(to, parent, child){
    let link = null
    if (this.props.currentApproval) {
      link = (
        <Link spy={true} smooth={true} duration={500} to={to} containerId={parent}>
          { child }
        </Link>
      )
    }
    return link
  }

  render() {
    let approversIcon = ( <SideNavApproverIconButton/> )
    let commentsIcon = ( <SideNavCommentIconButton/> )
    let specsIcon = ( <SideNavSpecificationIconButton/> )
    let historyIcon = ( <SideNavHistoryIconButton/> )

    return (
      <Navigation theme={theme} type='vertical'>
        { this.createLink('specContainer', 'scrollContainer', specsIcon) }
        { this.createLink('approvalContainer', 'scrollContainer', approversIcon) }
        { this.createLink('commentContainer', 'scrollContainer', commentsIcon) }
        { this.createLink('historyContainer', 'scrollContainer', historyIcon) }
      </Navigation>
    )
  }
}
export default CSSModules(SideNavBar, theme)
